// extracted by mini-css-extract-plugin
export default {"page":"styles_page__u7z3Q","head":"styles_head__U6Ze6","button":"styles_button__S4js1","canvas":"styles_canvas__+K6KJ"};